import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { PinnedPlayerInput_InputAdapter_instance3l0uktocaqjwt as PinnedPlayerInput_InputAdapter_instance } from './PinnedPlayerInput_InputAdapter.mjs';
import {
  obj2vqjd1bjrpmyg as obj,
  list2lpjhmv1d2k19 as list,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { PinInput_InputAdapter_instanceu2c9tbw0jdrf as PinInput_InputAdapter_instance } from './PinInput_InputAdapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PinnedPairInput36po72mbn91ld as PinnedPairInput } from '../PinnedPairInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PinnedPairInput_InputAdapterClass;
function PinnedPairInput_InputAdapter() {
  if (PinnedPairInput_InputAdapterClass === VOID) {
    class $ {
      o3z(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      q6p(writer, customScalarAdapters, value) {
        writer.r47('players');
        list(obj(PinnedPlayerInput_InputAdapter_instance)).w40(writer, customScalarAdapters, value.f6n_1);
        writer.r47('pins');
        list(obj(PinInput_InputAdapter_instance)).w40(writer, customScalarAdapters, value.g6n_1);
      }
      p3z(writer, customScalarAdapters, value) {
        return this.q6p(writer, customScalarAdapters, value instanceof PinnedPairInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'PinnedPairInput_InputAdapter', VOID, VOID, [Adapter()]);
    PinnedPairInput_InputAdapterClass = $;
  }
  return PinnedPairInput_InputAdapterClass;
}
var PinnedPairInput_InputAdapter_instance;
function PinnedPairInput_InputAdapter_getInstance() {
  return PinnedPairInput_InputAdapter_instance;
}
//region block: init
PinnedPairInput_InputAdapter_instance = new (PinnedPairInput_InputAdapter())();
//endregion
//region block: exports
export {
  PinnedPairInput_InputAdapter_instance as PinnedPairInput_InputAdapter_instance2c5u7hk53zzay,
};
//endregion

//# sourceMappingURL=PinnedPairInput_InputAdapter.mjs.map
